export default {
  methods: {
    sortData(data, sort) {
      let channelData = JSON.parse(JSON.stringify(data));
      let index = typeof channelData.options.classes === 'object' ? channelData.options.classes.findIndex(d => d === sort) : -1;
      let index1 = typeof channelData.options.classes1 === 'object' ? channelData.options.classes1.findIndex(d => d === sort) : -1;
      if (index !== -1) {
        let dataList = [];
        channelData.data.forEach((d) => {
          if (d.class === sort) {
            dataList.push(d);
          }
        });
        dataList.sort((x, y) => {
          return y.value - x.value;
        });
        let domainX = dataList.map(d => d.label);
        channelData.options.domainX.forEach((label) => {
          if (domainX.findIndex(d => d === label) < 0) {
            domainX.push(label);
          }
        });
        channelData.options.domainX = domainX;
        if (channelData.data1) {
          channelData.data1.forEach((d) => {
            let ilist = [];
            channelData.options.domainX.forEach((label) => {
              d.list.forEach((d) => {
                if (d.label === label) {
                  ilist.push(d);
                }
              });
            });
            d.list = ilist;
          });
        }
      } else if (index1 !== -1) {
        channelData.data1.forEach((d) => {
          if (d.title === sort) {
            d.list.sort((x, y) => {
              return y.value - x.value;
            });
            channelData.options.domainX = d.list.map(a => a.label);
          }
        });
      }
      return channelData;
    },
    fetchData(params) {
      // let { url, field, dataType, levelType, param, option = {}, sort } = params;
      let {
        url, field, param, option = {}, sort
      } = params;
      this[field] = Object.assign({}, JSON.parse(JSON.stringify(this[field])), { refresh: 1 });
      let data = {};
      // if (dataType) {
      //   data.date_type = this[dataType];
      // }
      // if (levelType) {
      //   data.level_type = this[levelType];
      // }
      if (typeof param === 'object' && param !== null) {
        data = Object.assign(data, param);
      }
      return this.$http
        ._post({ url, data })
        .then((result) => {
          let dataSet = {
            data: [], options: {}, refresh: 0, ex: {}
          };
          // result 为字符类型则为服务端报错  ：数据建设中
          if (result.result !== 0 || typeof result === 'string') {
            this[field] = Object.assign({}, JSON.parse(JSON.stringify(this[field])), { refresh: 2 });
            return dataSet;
          }
          let {
            title, data, data1, childData, xAxis, yAxis, yAxis1, classes, classes1, ex
          } = result.data;

          if (data) {
            dataSet.data = data;
          } else {
            this[field] = Object.assign({}, JSON.parse(JSON.stringify(this[field])), { refresh: 3 });
            return dataSet;
          }
          if (title) {
            dataSet.title = title;
          }
          if (ex) {
            dataSet.ex = ex;
          }
          if (data1) {
            dataSet.data1 = data1;
          }
          if (childData) {
            dataSet.childData = childData;
          }
          if (classes) {
            dataSet.options.classes = classes;
          }
          if (xAxis) {
            dataSet.options.domainX = xAxis;
          }
          if (yAxis) {
            dataSet.options.domainY = yAxis;
          }
          if (yAxis1) {
            dataSet.options.domainY1 = yAxis1;
          }
          if (classes1) {
            dataSet.options.classes1 = classes1;
          }
          if (option && Object.keys(option).length) {
            dataSet.options = Object.assign(dataSet.options, option);
          }
          if (sort) {
            if (classes && classes.length) {
              this[sort].options = [...classes];
            }
            if (classes1 && classes1.length) {
              this[sort].options = [...classes, ...classes1];
            }
            this[field] = this.sortData(dataSet, this[sort].value);
          } else {
            this[field] = dataSet;
          }
          // 自动判定图表高度--图例不定数且labelWidthPercent属性为数字时使用
          if (typeof dataSet.options.labelWidthPercent === 'number') {
            let classLength = dataSet.options.classes ? dataSet.options.classes.length : 0;
            classLength = dataSet.options.classes1 ? dataSet.options.classes1.length + classLength : classLength;
            dataSet.options.margin.top = Math.ceil((classLength * dataSet.options.labelWidthPercent) / 100) * 20;
          }
        });
    }
  }
};
